import {
  CodeBook,
  ExportTypeEnum,
  PagedResult,
} from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils/apiUtils";

import {
  CodeBookPagedFilter,
  SaveResult,
  OibServiceResult,
} from "../../models";
import {
  MinistryCommittee,
  CommitteeSearch,
  CommitteeStatus,
  CommitteeRole,
  OibEmployee,
} from "../../models/Committee";

const apiUrlPrefix: string = "ministry-committees";

export const getMinistryCommitteeById = async (id: number) => {
  return api.get(
    `${apiUrlPrefix}/get-committee/${id}`
  ) as Promise<MinistryCommittee>;
};

export const createMinistryCommittee = async () => {
  return api.get(
    `${apiUrlPrefix}/create-ministrycommittee`
  ) as Promise<MinistryCommittee>;
};

export const searchMinistryCommittee = async (search: CommitteeSearch) => {
  return api.post(`${apiUrlPrefix}/search-committees`, search) as Promise<
    PagedResult<MinistryCommittee>
  >;
};

export const getMinistryCommitteeStatusList = async () => {
  return api.get(`${apiUrlPrefix}/statuses-all`) as Promise<CodeBook[]>;
};

export const getMinistryCommitteeRoleList = async () => {
  return api.get(`${apiUrlPrefix}/roles-all`) as Promise<CommitteeRole[]>;
};

export const saveMinistryCommittee = async (item: MinistryCommittee) => {
  return api.put(`${apiUrlPrefix}/save-committee`, item) as Promise<
    SaveResult<MinistryCommittee>
  >;
};

export const searchMinistryCommitteeEmployee = async (
  search: CodeBookPagedFilter
) => {
  return api.post(`${apiUrlPrefix}/search-employees`, search) as Promise<
    PagedResult<CodeBook>
  >;
};

export const getMinistryCommitteeListExport = async (
  search: CommitteeSearch,
  type: ExportTypeEnum
) => {
  return api.download(
    `${apiUrlPrefix}/export/${type}`,
    "post",
    search
  ) as Promise<any>;
};
